export const deviceOS = navigator.platform.toUpperCase();

export const isMac = deviceOS.indexOf('MAC') >= 0;

export function setMetaTag(
    tagName: string,
    qualifiedName: string,
    value
): void {
    const metaTag = document.querySelector(`meta[name=${tagName}]`);
    if (!metaTag) {
        return;
    }

    metaTag.setAttribute(qualifiedName, value);
}

export function getMetaTag(tagName: string, attributeName: string): string {
    const metaTag = document.querySelector(`meta[name=${tagName}]`);
    if (!metaTag) {
        return null;
    }

    return metaTag.getAttribute(attributeName);
}

export function isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
}

export function isInAppBrowser() {
    if (window && window.isHBInAppBrowser) {
        return true;
    }
    return false;
}

export function getMobileDevice(): string | undefined {
    const devices = {
        Android: /Android/i,
        BlackBerry: /BlackBerry/i,
        iPhone: /iPhone/i,
        iPad: /iPad/i,
        iPod: /iPod/i,
        Opera: /Opera Mini/i,
        Windows: /IEMobile/i
    } as const;

    for (let device in devices) {
        if (navigator.userAgent.match(devices[device])) {
            return device;
        }
    }

    return undefined;
}

export function isSafari(): boolean {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}

export function isEdge(): boolean {
    return /Edge\/\d./i.test(navigator.userAgent);
}

export function isFireFox(): boolean {
    return navigator.userAgent.toLowerCase().includes('firefox');
}

export function getMobileOs() {
    const ua = navigator.userAgent;

    if (/iPad|iPhone|iPod/.test(ua)) {
        const uaindex = ua.indexOf('OS ');

        return {
            mobileOs: 'iOS',
            iosVersion:
                uaindex > -1
                    ? ua
                          .substring(uaindex + 3, ua.indexOf(' ', uaindex + 3))
                          .replace(/_/g, '.')
                    : undefined
        };
    } else if (/Android/.test(ua)) {
        const uaindex = ua.indexOf('Android ');

        return {
            mobileOs: 'Android',
            androidVersion:
                uaindex > -1
                    ? ua.substring(uaindex + 8, ua.indexOf(';', uaindex + 8))
                    : undefined
        };
    }

    return {};
}

export function isIOS(): boolean {
    if (isTouchDevice()) {
        return getMobileOs().mobileOs === 'iOS';
    }
    return false;
}

export function isAndroid(): boolean {
    if (isTouchDevice()) {
        return getMobileOs().mobileOs === 'Android';
    }
    return false;
}

export function isMobileDevice(): boolean {
    return !!getMobileDevice();
}
